export const clr = {
  mainBg: '#000',
  navbarBg: '#08283c',
  aboutbg: '#0d334a',
  btnColor: 'rgb(69,177,55)',
  maincolor: 'white',
  cancelBtn: '#a81317'
}
